<div>
    <div class="row">
        <div class="col-12">
            <div id="clientList" class="card">
                <ng-container *ngTemplateOutlet="pickList"></ng-container>
            </div>
        </div>
    </div>
</div>



<ng-template #pickList>

    <div class="card-header border-0">

        <div class=" d-flex align-items-center gap-2">
            <h5 class="fs-17 " style="padding-top: 0.5%;" i18n="@@">Login History</h5>

        </div>
    </div>
    <div class="card-header card-body bg-soft-light border border-dashed border-start-0 border-end-0">
        <div class="row g-3">
            <div class="col-sm-6 col-md-3">
     
                <div class="d-flex align-items-center " style="border-width: 1px; ">
                    <app-ng-select-layout-filter [placeHolderText]="'Select Status'" (statusChanged)="auditLogStatusFilter($event)" [items]="logEventOptions" ></app-ng-select-layout-filter>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body p-0">
        <div
            style="padding-right: 1rem; padding-left: 1rem; overflow: scroll; margin-bottom: 0;scrollbar-width: none; ">
            <div class="table-responsive table-card " style="margin-bottom: 0; margin-top: 0;">
                <table class="table align-middle table-nowrap" style="margin-bottom: 0;">
                    <thead class="text-muted table-light">
                        <tr>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Date</span>
                                    <div class="flex-shrink-0 " style="cursor: pointer;">
                                        <div *ngIf='sortBy != 1 && sortBy != 2' class="bx bxs-sort-alt me-1"
                                            (click)="sort(1)"></div>
                                        <div *ngIf='sortBy == 1' class="bx bx-caret-up me-1" (click)="sort(2)"></div>
                                        <div *ngIf='sortBy == 2' class="bx bx-caret-down me-1" (click)="sort(0)"></div>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">IP Address</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Browser</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Device</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <span class="flex-grow-1 " i18n="@@">Status</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="list form-check-all" style="cursor:default">
                        <tr *ngFor="let data of listItems" id="i_{{data.id}}">
                            <td>
                                <span>
                                    {{dateCovert(data.createdDate)}}
                                </span>
                            </td>
                            <td id="id_data.id" style="cursor:default">
                                <div class="d-flex align-items-center">
                                    <a href="javascript:void(0);">
                                        {{data.remoteIPAddress}}
                                    </a>
                                </div>

                            </td>
                            <td>
                                {{getHeadersBrowser(data.requestHeaders)}}
                            </td>
                            <td class="justify-content-center">
                                {{getHeadersDevice(data.requestHeaders)}}
                            </td>
                            <td class="justify-content-center">
                                <span class="rounded " [ngClass]=formatStyle(data.responsePayload)>
                                    {{formatResponse(data.responsePayload)}}
                                </span>
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>


    </div>
    <div class=" card-body ">
        <div class="row justify-content-md-between align-items-md-center">
            <div class="col col-sm-6">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{pagingInfo(auditLogService)}}
                </div>
            </div>
            <div class="col col-sm-6">
                <div class="text-sm-right float-end listjs-pagination">
                    <ngb-pagination [collectionSize]="(total | async)!" [(page)]="auditLogService.startIndex">
                        <ng-template ngbPaginationPages let-page let-pages="pages">
                            <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                                <div class="mb-3 d-flex flex-nowrap px-2">
                                    <label id="paginationInputLabel" for="paginationInput"
                                        class="col-form-label me-2 ms-1" i18n="@@Pagination_Text_Page">Page</label>
                                    <input #i type="text" inputmode="numeric" pattern="[0-9]*"
                                        class="form-control custom-pages-input" id="paginationInput"
                                        [value]="auditLogService.startIndex"
                                        (keyup.enter)="selectPage(auditLogService,i.value)"
                                        (blur)="selectPage(auditLogService,i.value)"
                                        (input)="formatPageInput($any($event).target)"
                                        aria-labelledby="paginationInputLabel paginationDescription"
                                        style="text-align: center; width:3.5rem;" />
                                    <span id="paginationDescription" class="col-form-label text-nowrap px-2 "> <span
                                            i18n="@@Pagination_Text_Of">of</span> {{pages.length}}</span>
                                </div>
                            </li>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </div>
        </div>
        <div *ngIf="isLoadingVal" id="elmLoader">
            <div class="spinner-border text-primary avatar-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</ng-template>